import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import styled from 'styled-components';

import BetaOpportunityItem from './betaOpportunityItem';
import SliderItemPlaceholder from '../../components/placeholders/sliderItemPlaceholder';
import { updateSearchTerm } from '../../modules/betaOpportunities';

const Slider = styled.section`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 12px;

  .slider-content { flex: 1; min-width: 0; }
  h2 { margin: 0 0 4px; font-size: 1.25rem; }
  p { margin: 0 0 14px; color: var(--br-muted); }
  .slider-heading-button {
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--br-text);
    cursor: pointer;
    font: inherit;
    font-weight: inherit;
    text-align: left;
  }
  .slider-heading-button:hover { color: var(--br-accent); }
  .slider-navigation {
    flex: 0 0 40px;
    height: 40px;
    border: 1px solid var(--br-border);
    border-radius: 50%;
    background: var(--br-surface);
    color: var(--br-text);
    cursor: pointer;
    font: inherit;
  }
  button:focus-visible {
    outline: 2px solid var(--br-focus);
    outline-offset: 2px;
  }
  @media (max-width: 767px) {
    .slider-navigation { display: none; }
  }
`;

const ContentSlider = ({ books = [], header, genre, loading, large }) => {
  const carouselRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const items = loading
    ? Array.from({ length: 15 }, (_, index) => <SliderItemPlaceholder key={index} />)
    : books.map(book => (
        <BetaOpportunityItem
          large={large}
          key={book._id}
          book={book}
          descriptionMaxLength={230}
        />
      ));

  return (
    <Slider aria-label={header?.title || t('Books', 'Books')}>
      <button
        className="slider-navigation"
        type="button"
        aria-label={t('PreviousBooks', 'Previous books')}
        onClick={() => carouselRef.current?.slidePrev()}
      >‹</button>
      <div className="slider-content">
        {loading ? (
          <div role="status" aria-label={t('LoadingBooks', 'Loading books')}>{t('Loading', 'Loading…')}</div>
        ) : header ? (
          <>
            <h2>
              {genre ? (
                <button className="slider-heading-button" type="button"
                  onClick={() => dispatch(updateSearchTerm(genre))}>
                  {header.title}
                </button>
              ) : header.title}
            </h2>
            {header.subheader && <p>{header.subheader}</p>}
          </>
        ) : null}
        <AliceCarousel
          startIndex={0}
          disableDotsControls
          disableButtonsControls
          infinite={!loading && books.length > 2}
          stagePadding={{ paddingLeft: 0, paddingRight: 50 }}
          items={items}
          mouseDragEnabled={false}
          responsive={{ 0: { items: 1 }, 600: { items: 1 }, 1024: { items: 2 } }}
          ref={carouselRef}
        />
      </div>
      <button
        className="slider-navigation"
        type="button"
        aria-label={t('NextBooks', 'Next books')}
        onClick={() => carouselRef.current?.slideNext()}
      >›</button>
    </Slider>
  );
};

export default ContentSlider;
